import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, Sparkles } from "lucide-react";

const BenefitSection = ({ benefits }) => {
  if (!benefits || benefits.length === 0) return null;

  return (
    <section className="py-6 lg:py-8">
      <div className="max-w-[1700px] mx-auto px-6 sm:px-8 lg:px-10 xl:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          viewport={{ once: true }}
          className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm"
        >
          {/* Header */}
          <div className="bg-gradient-to-r from-[#FF7A18] via-[#FF5B8A] to-[#9C4DFF] px-5 sm:px-6 lg:px-8 py-5">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/20">
                <Sparkles size={18} className="text-white" />
              </div>

              <div>
                <p className="text-[11px] uppercase tracking-[2px] text-white/80 font-medium">
                  WHY CHOOSE DATOULA
                </p>

                <h2 className="mt-1 text-xl sm:text-2xl lg:text-3xl font-bold text-white">
                  Business Benefits
                </h2>
              </div>
            </div>
          </div>

          {/* Body */}
          <div className="px-5 sm:px-6 lg:px-8 py-6">
            <p className="max-w-5xl text-[15px] leading-7 text-gray-600">
              Our AI-powered solutions help organizations automate
              operations, improve decision-making, optimize costs,
              and accelerate digital transformation through
              intelligent automation.
            </p>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              {benefits.map((item, index) => (
                <motion.div
                  key={index}
                  whileHover={{ y: -2 }}
                  transition={{ duration: 0.2 }}
                  className="flex items-start gap-3 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition-all duration-300 hover:border-[#EC4899]/40 hover:bg-white hover:shadow-md"
                >
                  <div className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-r from-[#FF7A18] via-[#FF5B8A] to-[#9C4DFF]">
                    <CheckCircle2
                      size={16}
                      className="text-white"
                    />
                  </div>

                  <p className="flex-1 text-[14px] sm:text-[15px] leading-6 text-gray-700">
                    {item}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default BenefitSection;